import React, { createContext, useState, useEffect } from "react";
const API_URL = process.env.REACT_APP_API_URL;

// Primeiro cria o contexto
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true); // <- Adicionado o controle de loading

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setUsuario(token);
    }
    setLoading(false); // <- Depois que buscar o token, desativa o loading
  }, []);

  const login = async (email, senha) => {
    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, senha }),
        credentials: 'include',
      });

      if (response.ok) {
        const token = await response.text();
        localStorage.setItem("token", token);
        setUsuario(token);
        return true;
      }
    } catch (error) {
      console.error("Erro ao logar:", error);
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
